module.exports = __webpack_public_path__ + "img/headphone.5b20e4a.svg";